import React from 'react';
import Breadcrumb from '../../components/BreadCrumb/BreadCrumb';
import Button from '../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import CsvUploadTable from '../BudgetSubmission/CsvUploadTable';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { calculateOperatingPerformance } from '../../redux/operatingSlice/operatingSlice';
import openNotification from '../../components/Common/OpenNotification';
import MastersTabBar from '../../components/Common/MastersTabBar/MastersTabBar';

export const UploadFiles = () => {
        const navigator = useNavigate();
        const userName = sessionStorage.getItem('name');
        const role = sessionStorage.getItem('role');
        const { uploadTablesStatus } = useSelector((state) => state.budget);
        const dispatch = useDispatch();

        const handleGotoFinalPreview = () => {
                if (uploadTablesStatus?.canProceed) {
                        navigator('/operating-performance/upload-files/final-preview');
                }
        };

        const handleCalculateOperatingPerformance = () => {
                dispatch(calculateOperatingPerformance());
                openNotification('info', 'Calculated', `Calculation Done`);
        };

        const tableData = [
                {
                        key: '2',
                        title: 'Project',
                        fileName: 'Project.csv',
                },
                {
                        key: '3',
                        title: 'Project Milestone',
                        fileName: 'project_milestone.csv',
                },
                {
                        key: '4',
                        title: 'Project Milestone Mapping',
                        fileName: 'project_milestone_mapping.csv',
                },
        ];

        return (
                <div className="p-5 flex flex-col gap-5 pb-20">
                        <MastersTabBar activeId="projectMilestone" />
                        <div className="flex flex-col gap-6">
                                <Breadcrumb />
                        </div>
                        <div className="flex flex-col gap-4">
                                <div className="flex items-center gap-2">
                                        <div className="font-medium text-[18px] leading-[28px] text-[#475467]">Upload Files</div>
                                        <Tooltip
                                                title={
                                                        <div>
                                                                Please download the Operating file only after uploading the following three files:
                                                                <br />
                                                                1️⃣ Notes to Operating
                                                                <br />
                                                                2️⃣ Personnel Payments
                                                                <br />
                                                                3️⃣ Miscellaneous Expenses
                                                                <br />
                                                                Additionally, please download and re-upload the Operating Performance file whenever any changes are made in the above files to ensure accuracy.
                                                        </div>
                                                }>
                                                <InfoCircleOutlined
                                                        style={{
                                                                color: '#1677ff',
                                                                cursor: 'pointer',
                                                        }}
                                                />
                                        </Tooltip>
                                </div>
                                <CsvUploadTable
                                        tableData={tableData}
                                        versionButtons={false}
                                        flowName="project"
                                />
                        </div>
                </div>
        );
};
